import type { ReactNode } from "react";
import clsx from "clsx";

export type AlertVariant = "info" | "success" | "warning" | "error";

const VARIANT_CLASSES: Record<AlertVariant, string> = {
  info: "bg-accent-soft border-accent/30 text-label",
  success:
    "bg-[color-mix(in_srgb,_var(--eh-green)_15%,_var(--eh-bg-card))] border-status-green/40 text-label",
  warning:
    "bg-[color-mix(in_srgb,_var(--eh-orange)_15%,_var(--eh-bg-card))] border-status-orange/40 text-label",
  error:
    "bg-[color-mix(in_srgb,_var(--eh-red)_15%,_var(--eh-bg-card))] border-status-red/40 text-label",
};

export interface AlertProps {
  variant?: AlertVariant;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function Alert({ variant = "info", title, children, className }: AlertProps) {
  return (
    <div
      role="status"
      className={clsx("rounded-lg border px-3 py-2 text-sm", VARIANT_CLASSES[variant], className)}
    >
      {title && <div className="font-semibold">{title}</div>}
      {children && <div className={clsx(title && "mt-1")}>{children}</div>}
    </div>
  );
}
